import { useMemo } from "react";
import useFeature from "hooks/useFeature";
import useCurrentUser from "hooks/useCurrentUser";
import { isPermitted } from "util/PermissionsMixin";
import useDataLakeConnectors from "data-lake/data-lake-connectors/useDataLakeConnectors";
const useStreamExternalDataLake = (stream) => {
  const currentUser = useCurrentUser();
  const previewFeatureIsEnabled = useFeature("data_lake_search");
  const externalPreviewFeatureIsEnabled = useFeature("external_data_lake_search");
  const canReadBackendConfig = isPermitted(currentUser.permissions, "data_lake_backend_config:read");
  const shouldCheckExternalDataLake = !stream.is_editable && previewFeatureIsEnabled && externalPreviewFeatureIsEnabled && canReadBackendConfig;
  const { data: connectors } = useDataLakeConnectors({
    enabled: shouldCheckExternalDataLake,
    refetchInterval: false
  });
  const externalConnector = useMemo(
    () => connectors == null ? void 0 : connectors.find(({ stream_id: connectorStreamId }) => connectorStreamId === stream.id),
    [connectors, stream.id]
  );
  if (!shouldCheckExternalDataLake || !(externalConnector == null ? void 0 : externalConnector.id)) {
    return {
      dataLakeId: void 0
    };
  }
  return {
    dataLakeId: externalConnector.id
  };
};
export default useStreamExternalDataLake;
